import RestfulProvider from "../globals/RestfulProvider";

const headers = {
  Accept: "application/json",
  "Content-type": "application/json",
  isAuthenticated: true,
};
const subUrllocal = "/api/v1/task";

class legalAssociateServices {
  getBatchwiseContractsAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/getBatchwiseContracts`, data, headers);
  getBatchListAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/getBatches`, data, headers);
}
// eslint-disable-next-line
export default new legalAssociateServices();
